var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterneticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_58_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 56.25H60V41.25C60 39.18 58.3237 37.5 56.25 37.5C54.1762 37.5 52.5 39.18 52.5 41.25V56.25H15C6.7275 56.25 0 62.9775 0 71.25V75C0 83.2725 6.7275 90 15 90H75C83.2725 90 90 83.2725 90 75V71.25C90 62.9775 83.2725 56.25 75 56.25ZM16.875 78.75C13.77 78.75 11.25 76.23 11.25 73.125C11.25 70.02 13.77 67.5 16.875 67.5C19.98 67.5 22.5 70.02 22.5 73.125C22.5 76.23 19.98 78.75 16.875 78.75ZM35.625 78.75C32.52 78.75 30 76.23 30 73.125C30 70.02 32.52 67.5 35.625 67.5C38.73 67.5 41.25 70.02 41.25 73.125C41.25 76.23 38.73 78.75 35.625 78.75ZM56.25 18.75C63.0637 18.75 69.4725 21.405 74.295 26.2238C75.7612 27.69 75.7612 30.0637 74.295 31.5262C73.5637 32.2575 72.6037 32.625 71.6437 32.625C70.6837 32.625 69.7237 32.2575 68.9925 31.5262C65.5912 28.1212 61.065 26.25 56.2537 26.25C51.4425 26.25 46.9162 28.125 43.515 31.5262C42.0525 32.9925 39.6787 32.9925 38.2125 31.5262C36.7462 30.0637 36.7462 27.69 38.2125 26.2238C43.0312 21.405 49.44 18.75 56.2537 18.75H56.25ZM23.3325 14.3175C31.8187 5.22 43.815 0 56.25 0C68.685 0 80.685 5.22 89.1675 14.3175C90.5812 15.8325 90.495 18.2062 88.98 19.62C88.26 20.295 87.3375 20.6287 86.4225 20.6287C85.4175 20.6287 84.42 20.2275 83.6812 19.4363C76.6087 11.8538 66.6112 7.50375 56.25 7.50375C45.8887 7.50375 35.8875 11.8538 28.8187 19.4363C27.4012 20.9513 25.0312 21.03 23.5162 19.62C22.0012 18.2062 21.9187 15.8325 23.3325 14.3175Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58_80"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterneticon);
export default __webpack_public_path__ + "static/media/interneticon.e279f6a524544a672d18e62ca3e2eeff.svg";
export { ForwardRef as ReactComponent };